
export default (content) => {
    return (dispatch) => {
        dispatch({ type: 'fetch_password_success', payload: content })
    }
}